import types from '../../../../../../../actions/types';

export function saveNewGame(data, resolve, reject) {
    return {type: types.SAVE_NEW_GAME.REQUEST, payload: {data, resolve, reject}};
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/new/modules/game-new-actions.js